import { useEffect, useState } from "react";
import AppLayout from "@/components/layout/AppLayout";
import { apiPrivate } from "@/lib/api";

export default function AdminRichieste() {
    const [reqs, setReqs] = useState([]);
    const [filter, setFilter] = useState("");

    const load = () => {
        const q = filter ? `?status_filter=${filter}` : "";
        apiPrivate.get(`/admin/access-requests${q}`).then(r => setReqs(r.data));
    };
    useEffect(() => { load(); }, [filter]);

    const setStatus = async (id, status) => {
        await apiPrivate.patch(`/admin/access-requests/${id}?status=${status}`);
        load();
    };

    return (
        <AppLayout admin>
            <div className="max-w-[1400px] mx-auto" data-testid="admin-requests">
                <span className="label-tag text-magenta">Richieste accesso</span>
                <h1 className="font-display text-5xl mt-3 tracking-tighter">Verifiche <span className="font-serif-italic text-acid">manuali</span>.</h1>

                <div className="mt-6 flex gap-2" data-testid="req-filters">
                    {[{ k: "", l: "Tutte" }, { k: "pending", l: "Pending" }, { k: "approved", l: "Approvate" }, { k: "rejected", l: "Rifiutate" }].map(b => (
                        <button key={b.k || "all"} onClick={() => setFilter(b.k)} data-testid={`req-filter-${b.k || "all"}`} className={`px-3 py-2 text-xs uppercase tracking-widest font-grotesk border ${filter === b.k ? "border-acid text-acid" : "border-zinc-800 text-zinc-500"}`}>{b.l}</button>
                    ))}
                </div>

                <div className="bento p-0 mt-6 overflow-x-auto" data-testid="req-table">
                    <table className="w-full text-sm">
                        <thead className="border-b border-zinc-900 text-left">
                            <tr className="font-grotesk uppercase text-xs tracking-widest text-zinc-500">
                                <th className="p-4">Nome</th>
                                <th className="p-4">Email richiesta</th>
                                <th className="p-4">CF</th>
                                <th className="p-4">Stato</th>
                                <th className="p-4">Data</th>
                                <th className="p-4 text-right">Azioni</th>
                            </tr>
                        </thead>
                        <tbody>
                            {reqs.length === 0 && <tr><td colSpan={6} className="p-10 text-center text-zinc-500" data-testid="req-empty">Nessuna richiesta.</td></tr>}
                            {reqs.map(r => (
                                <tr key={r.id} className="border-b border-zinc-900" data-testid={`req-row-${r.id}`}>
                                    <td className="p-4 font-grotesk">{r.nome} {r.cognome}</td>
                                    <td className="p-4 text-zinc-400">{r.email_richiesta}</td>
                                    <td className="p-4 font-mono text-zinc-500 text-xs">{r.codice_fiscale || "—"}</td>
                                    <td className="p-4">
                                        <span className={`text-xs uppercase tracking-widest font-grotesk px-2 py-1 border ${r.status === "approved" ? "border-acid text-acid" : r.status === "rejected" ? "border-magenta text-magenta" : "border-zinc-700 text-zinc-400"}`}>{r.status}</span>
                                    </td>
                                    <td className="p-4 text-zinc-500 text-xs">{new Date(r.created_at).toLocaleDateString("it-IT")}</td>
                                    <td className="p-4 text-right">
                                        {r.status === "pending" && (
                                            <div className="flex gap-2 justify-end">
                                                <button onClick={() => setStatus(r.id, "approved")} className="text-xs uppercase tracking-widest font-grotesk text-acid hover:underline" data-testid={`approve-${r.id}`}>Approva</button>
                                                <button onClick={() => setStatus(r.id, "rejected")} className="text-xs uppercase tracking-widest font-grotesk text-magenta hover:underline" data-testid={`reject-${r.id}`}>Rifiuta</button>
                                            </div>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </AppLayout>
    );
}
